import React from 'react';
import { GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridFooter } from '@mui/x-data-grid-pro';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaChevronDown } from 'react-icons/fa';


const Toolbar = ( { selectedRows, handleModal, hasTxting, hasPhoneBurner, canExport, viewing } ) => {
    return (
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                {
                                                    viewing.length > 1 ? (
                                                        <Dropdown.Item disabled={true}>*** Some Actions Only Available While Viewing Single Account</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Dropdown.Item onClick={ () => handleModal( 'email-mass' ) } disabled={viewing.length !== 1}>Send Mass Email</Dropdown.Item>
                                                {
                                                    hasTxting ? (
                                                        <Dropdown.Item onClick={ () => handleModal( 'sms-mass' ) } disabled={viewing.length !== 1}>Send Mass Txt</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                {
                                                    hasPhoneBurner ? (
                                                        <>
                                                            <Dropdown.Divider />
                                                            <Dropdown.Item onClick={ () => handleModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                        </>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Dropdown.Divider />
                                                <Dropdown.Item onClick={ () => handleModal( 'list' ) } disabled={viewing.length !== 1}>Add to a List</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleModal( 'event' ) } disabled={viewing.length !== 1}>Add to an Event</Dropdown.Item>
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}

export default Toolbar;